export var getOrigin = function getOrigin() {
  return window.location.origin;
};